<template>
  <section class="hero is-fullheight LP-container">
    <TopHeader :ismenu='false'></TopHeader>
    <TermsBody></TermsBody>
  </section>
</template>

<script>
import TopHeader from '@/views/Top/TopHeader'
import TermsBody from '@/views/Terms/TermsBody'
export default {
  name: 'Terms',
  components: {
    TopHeader,
    TermsBody
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.LP-container {
  height: 100vh;
  text-align: left;
  position: relative;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/pages/Terms.vue